import { ComponentStyleProps } from "../../../lib/styles/props/component-style-props";
import React from "react";
import {
  Box,
  ComponentMultiStyleConfig,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import { MainCommentBlockContent } from "../types";
import { CMCommentHeader } from "../CMCommentHeader/CMCommentHeader";
import { CMCommentTitle } from "../CMCommentTitle/CMCommentTitle";
import { CMMainCommentBlockItem } from "../CMMainCommentBlockItem/CMMainCommentBlockItem";

export type CMMainCommentBlockProps = {
  /**
   * コメントスレッドID
   */
  commentThreadId: string;

  /**
   * 表示用のデータ
   */
  content: MainCommentBlockContent;

  /**
   * 未読フラグ
   * trueの場合: 未読
   */
  isUnread?: boolean;

  /**
   * 開閉ボタンイベント
   * @param commentId
   * @param isOpen 開閉状態
   * 開いている状態:true
   */
  onToggle: (commentId: string, isOpen: boolean) => void;

  /**
   * 既読更新イベント
   * @param commentId
   */
  onRead?: (commentId: string) => void;

  /**
   * ファイルが選択されたときに、そのファイルを引数として呼び出される。
   * @param fileId
   * @param fileName ファイル名
   */
  onDownloadFile?: (fileId: string, fileName: string) => void;
} & ComponentStyleProps;

/**
 * 質疑応答のメインコメント表示用コンポーネント
 */
export const CMMainCommentBlock = ({
  commentThreadId,
  content,
  isUnread = true,

  onToggle,
  onRead,
  onDownloadFile,

  sx,
  ...rest
}: CMMainCommentBlockProps) => {
  const styles = useMultiStyleConfig("CMMainCommentBlockStyles");

  return (
    <Box sx={{ ...styles.container, ...sx }} {...rest}>
      {/*ヘッダエリア*/}
      <CMCommentHeader
        headerContent={content.headerItem}
        date={content.date}
        sx={styles.headerArea}
      />

      {/*タイトルエリア*/}
      <CMCommentTitle
        isUnread={content.isUnread}
        messageRead={content.messageRead}
        messageUnread={content.messageUnread}
        title={content.title}
        sx={styles.titleArea}
      />

      {/*メインコメントエリア*/}
      <CMMainCommentBlockItem
        commentThreadId={commentThreadId}
        content={content.mainItem}
        isUnread={isUnread}
        onToggle={onToggle}
        onRead={onRead}
        onDownloadFile={onDownloadFile}
        sx={styles.mainArea}
      />
    </Box>
  );
};

export const CMMainCommentBlockStyles: ComponentMultiStyleConfig = {
  parts: ["container", "headerArea", "titleArea", "mainArea"],
  baseStyle: {
    container: {
      minW: "300px",
      overflow: "hidden",

      display: "flex",
      flexDirection: "column",
    },

    headerArea: {
      alignSelf: "stretch",
    },
    titleArea: {
      marginTop: "5px",
    },
    mainArea: {
      marginTop: "5px",
    },
  },
};
